import { render } from "./x.vue?vue&type=template&id=72e16d04"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/x.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72e16d04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72e16d04', __exports__)) {
    api.reload('72e16d04', __exports__)
  }
  
  module.hot.accept("./x.vue?vue&type=template&id=72e16d04", () => {
    api.rerender('72e16d04', render)
  })

}


export default __exports__